import { graphql, useStaticQuery } from "gatsby";

const useArticlesQuery = () => {
    // Get all files from "/data/articles"
    const { allMarkdownRemark } = useStaticQuery(graphql`
        query AllArticles {
            allMarkdownRemark(
                filter: {fileAbsolutePath: {regex: "/^.*\\/(articles)\\/.*$/"}},
                sort: {fields: frontmatter___date, order: DESC}
            ) {
                nodes {
                    html
                    frontmatter {
                        slug
                        title
                        metaDescription
                        cover
                        date(formatString: "DD/MM/YYYY")
                        category
                        tags
                    }
                }
            }
        }
    `);

    return ({ allMarkdownRemark });
};

export default useArticlesQuery;
